import { render, staticRenderFns } from "./IndexingDetails.vue?vue&type=template&id=5db31d84&scoped=true&"
import script from "./IndexingDetails.vue?vue&type=script&lang=js&"
export * from "./IndexingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db31d84",
  null
  
)

export default component.exports